import React from 'react'
import PublicLayout from '../layouts/PublicLayout';
import Login from '../pages/login/Login';
import { useRoutes } from 'react-router-dom';
import PrivateLayout from '../layouts/PrivateLayout';
import Dashboard from '../pages/dashboard/Dashboard';
import DashboardLayout from '../layouts/DashboardLayout';
import ParentList from '../pages/parent/ParentList';
import PermissionRoute from './PermissionRoute';
import NotFound from '../pages/notFound/NotFound';
import ViewParentDetail from '../pages/parent/ViewParentDetail';
import AddParent from '../pages/parent/AddParent';
import EditParent from '../pages/parent/EditParent';
import TutorList from '../pages/tutor/TutorList';
import AddTutor from '../pages/tutor/AddTutor';
import ViewTutorDetail from '../pages/tutor/ViewTutorDetail';
import EditTutor from '../pages/tutor/EditTutor';
import SubAdminList from '../pages/subAdmin/SubAdminList';
import ViewSubAdminDetail from '../pages/subAdmin/ViewSubAdminDetail';
import AddSubAdmin from '../pages/subAdmin/AddSubAdmin';
import EditSubAdmin from '../pages/subAdmin/EditSubAdmin';
import BookingList from '../pages/bookings/BookingList';
import BookingDetail from '../pages/bookings/BookingDetail';
import CouponCodeList from '../pages/couponCode/CouponCodeList';
import AddCouponCode from '../pages/couponCode/AddCouponCode';
import EditCouponCode from '../pages/couponCode/EditCouponCode';
import ViewCouponCodeDetail from '../pages/couponCode/ViewCouponCodeDetail';
import SubscriptionPlanList from '../pages/subscriptionPlans/SubscriptionPlanList';
import ViewSubscriptionPlanDetail from '../pages/subscriptionPlans/ViewSubscriptionPlanDetail';
import AddSubscriptionPlan from '../pages/subscriptionPlans/AddSubscriptionPlan';
import EditSubscriptionPlan from '../pages/subscriptionPlans/EditSubscriptionPlan';
import BadgeList from '../pages/badges/BadgeList';
import ReportedBookingList from '../pages/reportedBooking/ReportedBookingList';
import ViewReportedBookingDetail from '../pages/reportedBooking/ViewReportedBookingDetail';
import ReviewList from '../pages/review/ReviewList';
import ViewReviewDetail from '../pages/review/ViewReviewDetail';
import TutorReviewSummary from '../pages/review/ViewRatingSummary';
import About from '../pages/cms/About';
import Privacy from '../pages/cms/Privacy';
import Terms from '../pages/cms/Terms';
import Contact from '../pages/cms/Contact';
import FaqList from '../pages/cms/Faq';
import AddFaq from '../pages/cms/AddFaq';
import EditFaq from '../pages/cms/EditFaq';
import AddBadge from '../pages/badges/AddBadge';
import EditBadge from '../pages/badges/EditBadge';
import ViewBadgeDetail from '../pages/badges/ViewBadgeDetail';
import Earnings from '../pages/earnings/Earnings';
import ViewEarning from '../pages/earnings/ViewEarning';
import NotificationList from '../pages/notification/NotificationList';
import ViewNotificationDetail from '../pages/notification/ViewNotificationDetail';
import SendNotification from '../pages/notification/SendNotification';
import ForgetPass from '../pages/forgetPassword/ForgetPass';
import ResetPass from '../pages/resetPassword/ResetPass';
import PricingAndPayment from '../pages/cms/PricingAndPayment';
import RefundPolicy from '../pages/cms/RefundPolicy';
import ViewCmsContent from '../pages/cms/ViewCmsContent';
import TutorAgreement from '../pages/cms/TutorAgreement';
import Settlement from '../pages/settlement/Settlement';
import ViewSettlementDetail from '../pages/settlement/ViewSettlementDetail';

const RouteContainer = () => {

    const routes = [
        {
            path: '/view-page/:tag',
            element: <ViewCmsContent />
        },
        {
            path: "/",
            element: <PublicLayout />,
            children: [
                {
                    path: '/',
                    element: <Login />
                },
                {
                    path: '/login',
                    element: <Login />
                },
                {
                    path: '/forget-password',
                    element: <ForgetPass />
                },
                {
                    path: '/reset-password',
                    element: <ResetPass />
                }
            ]
        },
        {
            path: "/",
            element: <PrivateLayout />,
            children: [
                {
                    element: <DashboardLayout />,
                    children: [
                        {
                            path: '/dashboard',
                            element: <Dashboard />
                        },
                        {
                            path: '/parents',
                            element: (
                                <PermissionRoute module="parents" action="view">
                                    <ParentList />
                                </PermissionRoute>
                            ),
                        },
                        {
                            path: '/parents/view',
                            element: (
                                <PermissionRoute module="parents" action="view">
                                    <ViewParentDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/parents/add',
                            element: (
                                <PermissionRoute module="parents" action="add">
                                    <AddParent />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/parents/edit',
                            element: (
                                <PermissionRoute module="parents" action="edit">
                                    <EditParent />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/tutors',
                            element: (
                                <PermissionRoute module="tutors" action="view">
                                    <TutorList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/tutors/add',
                            element: (
                                <PermissionRoute module="tutors" action="add">
                                    <AddTutor />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/tutors/view',
                            element: (
                                <PermissionRoute module="tutors" action="view">
                                    <ViewTutorDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/tutors/edit',
                            element: (
                                <PermissionRoute module="tutors" action="edit">
                                    <EditTutor />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/subadmins',
                            element: (
                                <PermissionRoute module="subadmins" action="view">
                                    <SubAdminList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/subadmins/view',
                            element: (
                                <PermissionRoute module="subadmins" action="view">
                                    <ViewSubAdminDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/subadmins/add',
                            element: (
                                <PermissionRoute module="subadmins" action="add">
                                    <AddSubAdmin />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/subadmins/edit',
                            element: (
                                <PermissionRoute module="subadmins" action="edit">
                                    <EditSubAdmin />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/bookings',
                            element: (
                                <PermissionRoute module="bookings" action="view">
                                    <BookingList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/bookings/view',
                            element: (
                                <PermissionRoute module="bookings" action="view">
                                    <BookingDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/coupons',
                            element: (
                                <PermissionRoute module="coupons" action="view">
                                    <CouponCodeList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/coupons/add',
                            element: (
                                <PermissionRoute module="coupons" action="add">
                                    <AddCouponCode />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/coupons/edit',
                            element: (
                                <PermissionRoute module="coupons" action="edit">
                                    <EditCouponCode />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/coupons/view',
                            element: (
                                <PermissionRoute module="coupons" action="view">
                                    <ViewCouponCodeDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/subscriptions',
                            element: (
                                <PermissionRoute module="subscriptions" action="view">
                                    <SubscriptionPlanList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/subscriptions/view',
                            element: (
                                <PermissionRoute module="subscriptions" action="view">
                                    <ViewSubscriptionPlanDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/subscriptions/add',
                            element: (
                                <PermissionRoute module="subscriptions" action="add">
                                    <AddSubscriptionPlan />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/subscriptions/edit',
                            element: (
                                <PermissionRoute module="subscriptions" action="edit">
                                    <EditSubscriptionPlan />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/badges',
                            element: (
                                <PermissionRoute module="badges" action="view">
                                    <BadgeList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/badges/add',
                            element: (
                                <PermissionRoute module="badges" action="add">
                                    <AddBadge />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/badges/edit',
                            element: (
                                <PermissionRoute module="badges" action="edit">
                                    <EditBadge />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/badges/view',
                            element: (
                                <PermissionRoute module="badges" action="view">
                                    <ViewBadgeDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/reported-bookings',
                            element: (
                                <PermissionRoute module="reported-bookings" action="view">
                                    <ReportedBookingList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/reported-bookings/view',
                            element: (
                                <PermissionRoute module="reported-bookings" action="view">
                                    <ViewReportedBookingDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/reviews',
                            element: (
                                <PermissionRoute module="reviews" action="view">
                                    <ReviewList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/reviews/view',
                            element: (
                                <PermissionRoute module="reviews" action="view">
                                    <ViewReviewDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/reviews/tutor-summary',
                            element: (
                                <PermissionRoute module="reviews" action="view">
                                    <TutorReviewSummary />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/about',
                            element: (
                                <PermissionRoute module="about" action="view">
                                    <About />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/privacy',
                            element: (
                                <PermissionRoute module="privacy" action="view">
                                    <Privacy />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/terms',
                            element: (
                                <PermissionRoute module="terms" action="view">
                                    <Terms />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/refund-policy',
                            element: (
                                <PermissionRoute module="refund-policy" action="view">
                                    <RefundPolicy />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/pricing-payment',
                            element: (
                                <PermissionRoute module="pricing-payment" action="view">
                                    <PricingAndPayment />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/tutor-agreement',
                            element: (
                                <PermissionRoute module="tutor-agreement" action="view">
                                    <TutorAgreement />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/contact',
                            element: (
                                <PermissionRoute module="contact" action="view">
                                    <Contact />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/faq',
                            element: (
                                <PermissionRoute module="faq" action="view">
                                    <FaqList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/faq/add',
                            element: (
                                <PermissionRoute module="faq" action="add">
                                    <AddFaq />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/faq/edit',
                            element: (
                                <PermissionRoute module="faq" action="edit">
                                    <EditFaq />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/earnings',
                            element: (
                                <PermissionRoute module="earnings" action="view">
                                    <Earnings />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/earnings/view',
                            element: (
                                <PermissionRoute module="earnings" action="view">
                                    <ViewEarning />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/settlement',
                            element: (
                                <PermissionRoute module="settlement" action="view">
                                    <Settlement />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/settlement/view',
                            element: (
                                <PermissionRoute module="settlement" action="view">
                                    <ViewSettlementDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/notification',
                            element: (
                                <PermissionRoute module="notification" action="view">
                                    <NotificationList />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/notification/view',
                            element: (
                                <PermissionRoute module="notification" action="view">
                                    <ViewNotificationDetail />
                                </PermissionRoute>
                            )
                        },
                        {
                            path: '/notification/send',
                            element: (
                                <PermissionRoute module="notification" action="add">
                                    <SendNotification />
                                </PermissionRoute>
                            )
                        },
                    ]
                }
            ]
        },
        {
            path: "*",
            element: <NotFound />
        }
    ]
    return (
        <>
            {useRoutes(routes)}
        </>
    )
}

export default RouteContainer;